import { render, staticRenderFns } from "./appHeadersarpa.vue?vue&type=template&id=f2741c20"
import script from "./appHeadersarpa.vue?vue&type=script&lang=js"
export * from "./appHeadersarpa.vue?vue&type=script&lang=js"
import style0 from "./appHeadersarpa.vue?vue&type=style&index=0&id=f2741c20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports